import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectTypeDefinitionsFetchFailedAction = {
	type: 'SUBJECT_TYPE_DEFINITIONS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectTypeDefinitionsFetchFailedAction => ({
	type: 'SUBJECT_TYPE_DEFINITIONS_FETCH_FAILED',
	payload,
});
